

































































import {Component, Mixins} from 'vue-property-decorator';
import CompSelectBox from '@/components/common/CompSelectBox.vue';
import AmountMixin from '@/components/claim/popup/mixins/AmountMixin';

@Component({
  components: {
    CompSelectBox
  },
  computed: {
    lineThrough(){
      return this.claimNoResponseData.responsibleObjectType === 'SELLER' ? 'line-through':'none'
    },

    isReturnDeliveryPrepaid(){
      return this.claimNoResponseData.claimData.shipping.prepaid;
    },

    isExchangeShippingPrepaid(){
      return this.claimNoResponseData.claimData.exchangeShipping.prepaid;
    }
  }
})
export default class ReturnExchangeDeliveryAmount extends Mixins(AmountMixin){
  // 반품배송비 row
  private returnDelivery = {
    returnDeliveryAmt: 0, // 기본배송비
    returnRemoteDeliveryAmt: 0, // 지역별추가
    returnDeliveryAdjustAmt: 0, // 금액조정(선택)
    returnDeliveryAmtAdjustReason: '', // 조정사유
  }

  // 교환(재발송) 배송비 row
  private exchangeDelivery = {
    deliveryAmt: 0, // 기본배송비
    remoteDeliveryAmt: 0, // 지역별추가배송비
    exchangeDeliveryAdjustAmt: 0, // 금액조정(선택)
    exchangeDeliveryAmtAdjustReason: '', // 조정사유
  }

  // 배송비합계 (b) row
  private totalDelivery = {
    totalDeliveryAmt: 0,
  }

  created(){
    this.setReturnDelivery()
    this.setExchangeDelivery()
    this.setTotalDelivery()
  }

  private setReturnDelivery() {
    const {returnDeliveryAmt, returnRemoteDeliveryAmt} = this.amounts.returnDelivery
    const {returnDeliveryAdjustAmt, returnDeliveryAmtAdjustReason} = this.claimNoResponseData

    this.returnDelivery = {
      returnDeliveryAmt,
      returnRemoteDeliveryAmt,
      returnDeliveryAdjustAmt,
      returnDeliveryAmtAdjustReason,
    }
  }

  private setExchangeDelivery(){
    const {deliveryAmt, remoteDeliveryAmt} = this.amounts.exchangeDelivery
    const {exchangeDeliveryAmtAdjustReason} = this.claimNoResponseData
    const exchangeDeliveryAdjustAmt = this.amounts.exchangeDeliveryAdjustAmt

    this.exchangeDelivery = {
      deliveryAmt,
      remoteDeliveryAmt,
      exchangeDeliveryAdjustAmt,
      exchangeDeliveryAmtAdjustReason,
    }
  }

  // https://nhnent.dooray.com/project/posts/2711631288263591700
  // 판매자 귀책 시, 배송비들이 삭선처리 됨. 즉 합계는 0원
  // 배송비합계 = 반품기본배송비 + 반품지역별추가배송비 - 반품조정금액 + 교환기본배송비 + 교환지역별추가배송비 - 교환조정금액
  private setTotalDelivery() {
    const isPrepaid = this.claimNoResponseData.claimData.shipping.prepaid

    const {prepaidReturnDeliveryAmt, prepaidReturnRemoteDeliveryAmt} = this.amounts.returnDelivery
    const returnDeliveryAdjustAmt = this.returnDelivery.returnDeliveryAdjustAmt

    const {prepaidDeliveryAmt: prepaidExchangeDeliveryAmt, prepaidRemoteDeliveryAmt: prepaidExchangeRemoteDeliveryAmt} = this.amounts.exchangeDelivery
    const exchangeDeliveryAdjustAmt = this.amounts.exchangeDeliveryAdjustAmt

    this.totalDelivery.totalDeliveryAmt = prepaidReturnDeliveryAmt + prepaidReturnRemoteDeliveryAmt - (isPrepaid ? returnDeliveryAdjustAmt : 0) + prepaidExchangeDeliveryAmt + prepaidExchangeRemoteDeliveryAmt - (isPrepaid ? exchangeDeliveryAdjustAmt : 0)
  }
}
